<template>
  <div class="wrap qw_transfer_promote">
    <van-pull-refresh
      v-model="isLoading"
      success-text="刷新成功"
      :disabled="visible || disabledPull || activityInfo.activityStatus !== 1"
      @refresh="onRefresh"
    >
      <div v-if="!isLive" class="pageNative flex_center">
        <div class="rule float" @click="onShowRule">活动规则</div>
        <div class="nativeStatus flex_center">
          活动已结束
        </div>
      </div>
      <div v-else class="pageNative" :class="{ skin_1: skin === 1, skin_2: skin === 2 }">
        <div class="rule float" @click="onShowRule">活动规则</div>
        <div class="main">
          <div class="headder">
            <img :src="activityInfo.icon" alt="">
          </div>
          <div class="game bg_contain flex_a_c">
            <div class="game_main flex_a_c">
              <div class="game_icon mr_14 bg_contain" :style="{ backgroundImage: `url(${gameInfo.icon})` }"></div>
              <div class="game_info flex_1">
                <div class="game_title fs_18 color_white">{{ gameInfo.name }}</div>
                <div class="game_tags mt_8"></div>
              </div>
              <div class="game_btn bg_contain" @click="onStartGame"></div>
            </div>
          </div>
          <div class="info flex_between mb_8 pl_8">
            <template v-if="hasBinded">
              <div class="d_flex account">
                <div class="role_name color_white mr_2 van-ellipsis">{{ activityInfo.roleName }}-{{ activityInfo.roleId }}</div>
                <div class="role_bind account_btn text_nowrap" @click="onClickChangeBind">切换角色</div>
              </div>
            </template>
            <template v-else>
              <div class="d_flex pl_6 account">
                <div class="role_label mr_4 color_grey">未确认角色</div>
                <div class="account_btn text_nowrap" @click="onClickBind">确认角色</div>
              </div>
            </template>
            <div
              v-if="hasBinded"
              class="record pr_14 text_nowrap"
              @click="onShowRecord"
            >
              <span>领取记录</span>
              <i class="iconfont yw-xiangyou fs_15"></i>
            </div>
          </div>
          <div class="blocks">
            <div class="block_list">  
              <div class="block_item" v-for="bk in activityInfo.moduleVoList" :key="bk.moduleId">
                <div class="block relative">
                  <div class="block_bg block_bg_top bg_cover"></div>
                  <div class="block_bg block_bg_mid bg_cover"></div>
                  <div class="block_bg block_bg_bottom bg_cover"></div>
                  <div class="block_content">
                    <div class="block_top flex_a_b">
                      <div class="block_top_title bg_cover">
                        <div class="block_top_main relative" :data-text="bk.moduleName"></div>
                      </div>
                      <div v-if="bk.moduleSubName" class="block_top_sub bg_cover">{{ bk.moduleSubName }}</div>
                    </div>
                    <div class="block_gifts">
                      <div class="block_gift_item flex_a_c" v-for="gift in bk.moduleRewardVoList" :key="gift.moduleRewardId">
                        <div class="block_gift_icon bg_contain" :style="{ backgroundImage: `url(${gift.giftIcon})` }"></div>
                        <div class="block_gift_info flex_1" style="width: 0;">
                          <div class="block_gift_name color_white mb_6 van-ellipsis">{{ gift.rewardName }}</div>
                          <div class="block_gift_condition mb_2">{{ gift.drawCondit }}</div>
                          <div class="block_gift_content van-multi-ellipsis--l2">{{ gift.giftDesc }}</div>
                        </div>
                        <div class="block_gift_op">
                          <div
                            class="block_gift_btn mb_8 fs_12 flex_center bold"
                            :class="{ 'block_gift_btn_disable': gift.drawStatus === 1 }"
                            @click="onReceive(gift, bk)"
                          >
                            {{ gift.drawStatus === 1 ? '已领取' : '领取' }}
                          </div>
                          <div class="block_gift_frequency text_center">{{ gift.refresh === 1 ? '限领一次' : '每日刷新' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="play flex_center pt_6 pb_8">
            <div class="play_btn flex_center" @click="onPlayGame">
              <span class="play_btn_text">在线玩</span>
            </div>
          </div>
        </div>
        <Record ref="recordRef" :activityId="params.activityId" @close="disabledPull = false" />
      </div>
      <Popup
        :visible.sync="visible"
        v-bind="feedback"
        :skins="{
          headerBg: skin === 1 ? '#FF9C47' : '#8472F7'
        }"
        :innerTitleStyle="{color: '#ED804B'}"
        confirmButtonColor="#FF9C47"
        cancelButtonColor="#00BFD3"
        @confirm="feedback.onSure"
      >
        <template v-if="feedbackType === FEEDTYPE_MAP.RULE">
          <p class="rule_wrap" style="white-space: pre-wrap; text-align: left">{{ activityInfo.rule }}</p>
        </template>
        <template v-if="feedbackType === FEEDTYPE_MAP.SUCCESS">
          <div class="receive_success">
            <div class="receive_success_main flex_a_c fs_16 mb_18">
              <div class="receive_s_label fs_16 mr_4 van-ellipsis">{{ curGift.rewardName }}：</div>
              <div class="receive_s_value">
                <div v-clipboard="curCdk" class="receive_s_success flex_a_c">
                  <div class="receive_s_cdk mr_4">{{ curCdk }}</div>
                  <div class="receive_s_btn fs_12 text_nowrap">
                    复制
                  </div>
                </div>
              </div>
            </div>
            <div class="receive_success_content d_flex color_grey mb_18">
              <div class="fs_12 text_nowrap">惊喜内容：</div>
              <div class="fs_12 van-multi-ellipsis--l2">{{ curGift.giftDesc }}</div>
            </div>
            <div class="fs_12 text_center" style="color: #FF4747">惊喜时间有限，请及时前往游戏中兑换</div>
          </div>
        </template>
        <template v-if="feedbackType === FEEDTYPE_MAP.CONDITION_NOT_SATISFY">
          <div class="receive_fail">
            <div class="receive_fail_title">
              <span>{{ errorMsgFilter[0] }}</span>
              <span style="color: #FF4747;" v-if="errorMsgFilter[1]">{{ errorMsgFilter[1] }}</span>
            </div>
            <div class="receive_fail_content flex_a_c mt_12">
              <div class="receive_fail_icon bg_contain" :style="{ backgroundImage: `url(${curGift.giftIcon})` }"></div>
              <div class="receive_fail_info">
                <div class="receive_fail_name mb_4">{{ curGift.rewardName }}</div>
                <div class="receive_fail_desc fs_12 van-multi-ellipsis--l2">{{ curGift.giftDesc }}</div>
              </div>
            </div>
          </div>
        </template>
      </Popup>
    </van-pull-refresh>
  </div>
</template>

<script>
import { ActivityInfo, FEEDTYPE_MAP } from './config'
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
import parseQuery from '@/mixins/parseQuery'
import { drawTransformPromoteGift, getTransformPromoteHome } from '@/apis/qiweiMiniGame';
import Popup from '@/components/Popup.vue';
import store from '@/store';
import Record from './record'

const {
  SUCCESS, RULE, CONDITION_NOT_SATISFY,
} = FEEDTYPE_MAP

export default {
  name: 'QiWeiTransferPromote',
  components: {
    Popup,
    Record,
  },
  data () {
    return {
      isLoading: false,
      visible: false,
      disabledPull: false,
      activityInfo: new ActivityInfo(),
      fields: ['activityId'],
      hasFetched: false,
      feedbackType: RULE,
      FEEDTYPE_MAP,
      curGift: {},
      curCdk: '',
      errorMsg: '',
    }
  },
  mixins: [parseQuery, trackingMixin],
  computed: {
    skin () {
      return this.activityInfo.styleType
    },
    gameInfo () {
      const { gameIcon, gameName, gameType } = this.activityInfo
      return {
        icon: gameIcon,
        name: gameName,
        type: gameType,
      }
    },
    isLive () {
      if (!this.hasFetched) return true
      if (!this.activityInfo.activityId) return false
      return [1].includes(this.activityInfo.activityStatus)
    },
    hasBinded () {
      return this.activityInfo.roleBind
    },
    trackActInfo () {
      return {
        activity_id: this.params.activityId,
        activity_name: this.activityInfo.name,
        game_id: this.activityInfo.gameId,
        game_name: this.activityInfo.gameName,
        role_id: this.activityInfo.roleId,
      }
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return {
        [RULE]: {
          title: '活动规则',
          showConfirmButton: false,
          onSure: () => {},
        },
        [CONDITION_NOT_SATISFY]: {
          title: '不满足领取条件',
          confirmButtonText: '去完成',
          onSure: () => {
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_enterprise_promote_to_complete_button,
              this.trackActInfo,
              { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
            )
            this.goLink()
          },
        },
        [SUCCESS]: {
          title: '领取成功',
          showConfirmButton: false,
          onSure: () => {},
        },
      }
    },
    errorMsgFilter () {
      const s = this.errorMsg
      if (!s.includes('（')) return [s]
      const [text, digit] = s.split('（')
      return [text, `（${digit}`]
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getActInfo().then(res => {
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_enterprise_promote_page,
          this.trackActInfo,
          { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
        )
      })
    })
  },
  methods: {
    getActInfo () {
      return getTransformPromoteHome({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.params.activityId,
      }).then(res => {
        const { name } = res.data
        this.activityInfo = res.data || new ActivityInfo()
        document.title = name
        this.hasFetched = true
      }).catch((err) => {
        const { code } = err
        // 点击频繁
        if (code !== 1032) {
          this.hasFetched = true
        }
      })
    },
    onRefresh () {
      this.isLoading = true
      this.getActInfo().finally(res => {
        setTimeout(() => {
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_enterprise_promote_page,
            this.trackActInfo,
            { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
          )
          this.isLoading = false
        }, 800)
      })
    },
    onReceive (gift, bk) {
      if (!this.validBinded()) return
      if (gift.drawStatus === 1) return
      if (this.drawLoading) return
      this.drawLoading = true
      const { moduleRewardId, rewardName, drawCondit } = gift
      this.curGift = gift

      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_enterprise_promote_draw_button,
        {
          ...this.trackActInfo,
          reward_id: moduleRewardId,
          reward_name: rewardName,
          draw_condit: drawCondit,
        },
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )

      drawTransformPromoteGift({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.params.activityId,
        moduleRewardId: moduleRewardId,
      }).then(res => {
        const { cdk } = res.data
        if (cdk) {
          this.curCdk = cdk
          this.triggerVisible(true, SUCCESS)

          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_enterprise_promote_draw_success_pop,
            {
              ...this.trackActInfo,
              reward_id: moduleRewardId,
              reward_name: rewardName,
              draw_condit: drawCondit,
              cdk: cdk,
            },
            { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
          )
        } else {
          this.$toast('领取失败，请联系客服')
        }
        this.getActInfo()
      }).catch((err) => {
        const { code, msg } = err
        // 14030 - 首次充值不满足领取条件
        // 14031 - 当日累计付费不满足领取条件
        // 14032 - 累计付费不满足领取条件
        if ([14030, 14031, 14032].includes(code)) {
          const { msg: emsg, curValue, tarValue } = JSON.parse(msg || '{}')
          this.errorMsg = emsg
          this.triggerVisible(true, CONDITION_NOT_SATISFY)
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_enterprise_promote_draw_not_complete_pop,
            {
              ...this.trackActInfo,
              reward_id: moduleRewardId,
              reward_name: rewardName,
              draw_condit: drawCondit,
              cur_value: curValue,
              tar_value: tarValue,
            },
            { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
          )
        } else {
          this.$toast(msg)
        }
      }).finally(() => {
        setTimeout(() => {
          this.drawLoading = false
        }, 500)
      })
    },
    triggerVisible (visible, type) {
      if (visible && this.visible) return
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = visible
    },
    onShowRule () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_enterprise_promote_button,
        {
          ...this.trackActInfo,
          button_type: 1
        },
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.triggerVisible(true, RULE)
    },
    onClickChangeBind () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_enterprise_promote_cut_role_button,
        {
          ...this.trackActInfo,
          bindRoleNum: this.activityInfo.bindRoleNum,
        },
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.$nextTick(() => {
        this.goBindPage()
      })
    },
    onClickBind () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_enterprise_promote_bind_role_button,
        this.trackActInfo,
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.$nextTick(() => {
        this.goBindPage()
      })
    },
    // 打开奖励记录面板
    onShowRecord () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_enterprise_promote_button,
        {
          ...this.trackActInfo,
          button_type: 2
        },
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.$refs.recordRef.triggerVisible(true)
      this.disabledPull = true
    },
    // 验证当前是否已绑定
    validBinded () {
      if (!this.hasBinded) {
        this.goBindPage()
        return false
      }
      return true
    },
    // 跳转绑定
    goBindPage () {
      this.triggerVisible(false)
      this.$router.push({
        name: 'accountBindInQWTP',
        query: {
          uid: this.activityInfo.uid,
          activityId: this.params.activityId,
          name: this.activityInfo.name,
          wx_app_id: this.$storeGet('WX_APP_ID'),
        }
      })
    },
    // 一键启动
    onStartGame () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_enterprise_promote_play_button,
        this.trackActInfo,
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.goLink()
    },
    // 在线玩
    onPlayGame () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_enterprise_promote_play_button,
        this.trackActInfo,
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.goLink()
    },
    goLink () {
      const target = this.activityInfo.planUrl
      if (target) {
        setTimeout(() => {
          this.triggerVisible(false)
          this.$nextTick(() => {
            window.location.href = target
          })
        }, 500)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import './skins.scss';
.main {
  padding-bottom: 64px;
}
.rule {
  top: 12px;
}
.float {
  position: fixed;
  z-index: 10;
  right: -2px;
  color: #fff;
  font-size: 12px;
  border-radius: 100px 0px 0px 100px;
  padding: 5px 8px;
  border: 1px solid #F8E26B;
  background-color: #C34336;
}
.headder {
  img {
    width: 100%;
  }
}
.game {
  position: relative;
  margin-top: -26px;
  background-size: 100% 100%;
  min-height: 120px;
  padding: 26px 4px 22px 22px;
  .game_main {
    width: 100%;
  }
  .game_icon {
    width: 56px;
    height: 56px;
  }
  .game_btn {
    width: 117px;
    height: 40.5px;
    background-image: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/gogame1.png');
  }
}
.play_btn {
  background-image: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/gm_btn1.png');
  width: 278px;
  height: 48px;
  background-size: 100% 100%;
  .play_btn_text {
    color: #741e258f;
    font-size: 22px;
    font-weight: bold;
    font-style: italic;
  }
}

.blocks {
  padding: 0 6px;
  .block_item + .block_item {
    margin-top: 8px;
  }
}

.block {
  width: 365px;
  height: fit-content;
  .block_bg {
    position: absolute;
    width: 100%;
    left: 0;
  }
  .block_bg_top {
    top: 0;
    height: 40px;
  }
  .block_bg_mid {
    top: 39px;
    height: calc(100% - 78px);
    background-size: 100% 100%;
  }
  .block_bg_bottom {
    bottom: 0;
    height: 40px;
  }
  .block_content {
    position: relative;
    z-index: 2;
    padding: 10px 0 18px;
  }
  .block_gifts {
    padding: 12px 12px 8px 14px;
  }
  .block_gift_item + .block_gift_item {
    margin-top: 8px;
  }
  .block_gift_item {
    padding: 12px 6px 8px 8px;
    border-radius: 8px;
    .block_gift_icon {
      width: 56px;
      height: 56px;
      margin-right: 8px;
    }
    .block_gift_condition {
      font-size: 11px;
      color: #86EEF8;
    }
    .block_gift_content {
      font-size: 11px;
      line-height: 13px;
      color: #FF9524;
    }
    .block_gift_frequency {
      font-size: 10px;
    }
  }
  .block_gift_btn {
    width: 75px;
    height: 30px;
    border-radius: 50px;
  }
  .block_gift_frequency {
    font-size: 10px;
  }

  .block_top_title {
    width: 120px;
    height: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    font-size: 15px;
    position: relative;
  }

  .block_top_sub {
    padding: 4px 6px;
    padding-right: 16px;
    font-style: italic;
    font-weight: bold;
    font-size: 15px;
    margin-left: -4px;
    background-size: 100% 100%;
  }
}

.block_gift_btn_disable {
  background-color: grey !important;
  color: white !important;
}

.info {
  position: relative;
  top: -6px;
  font-size: 15px;
  .account {
    .role_name {
      max-width: 210px;
    }
    .account_btn {
      text-decoration: underline;
    }
  }
}

.play {
  position: fixed;
  bottom: 0px;
  z-index: 9;
  width: 100vw;
  // background-color: #00000030;
}

.receive_fail_content {
  width: 100%;
  background-color: #F1F1F1;
  border-radius: 12px;
  padding: 8px 16px;
  font-size: 16px;
  .receive_fail_icon {
    width: 54px;
    height: 54px;
    margin-right: 12px;
  }
  .receive_fail_desc {
    color: #4C4C4C;
  }
  .receive_fail_info {
    flex: 1;
    width: 0;
  }
}

.receive_s_btn {
  background-color: #14B820;
  border-radius: 100px;
  padding: 6px 20px;
  color: #fff;
}
</style>
